module.exports = __webpack_public_path__ + "50c567a16bbdd06202e3efa70a9c92b3.woff";